import { Injectable } from '@angular/core';

import { LocalStorageService } from '@tablesready/frontend-storage';
import { LoggerService } from '@tablesready/frontend-logger';

// TODO: think about how to move it into application level
@Injectable({providedIn: 'root'})
export class LastLocationIdService {
  private readonly key = 'last-location-id';

  constructor(
    private readonly localStorageService: LocalStorageService,
    private readonly logger: LoggerService,
  ) {
  }

  set(locationId: string): void {
    try {
      this.localStorageService.set(this.key, locationId);
    } catch (err) {
      this.logger.error(err);
    }
  }

  get(): string {
    return this.localStorageService.get(this.key);
  }

  remove(): void {
    this.localStorageService.remove(this.key);
  }
}
